import type { QueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/hooks/query-keys'

import type { ProjectQueryScope } from './project-query-scope'
import { subscribeRecordInvalidation } from './record-query-invalidation'

export function subscribeProjectInvalidation(
  client: QueryClient,
  scope: ProjectQueryScope,
) {
  return subscribeRecordInvalidation(client, scope, queryKeys.projects)
}
